import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import  Dashboard from "./pages/Dashboard"
import VenderLogin from "./pages/venderlogin"




// Routes mein add k
function App() {
  return (
    <div style={{ fontFamily: "Quicksand" }}>
      <Router>
        <Routes>
          
          <Route path="/VenderLogin" element={<VenderLogin />} />
          <Route path="/Dashboard/*" element={<Dashboard />} />
       
          
        </Routes>
      </Router>
    </div>
  );
}

export default App;
